export default "__VITE_ASSET__BfZ9XUPS__"